export const MIN_PARAMETER_COUNT = 1;
export const MIN_TARGET_COUNT = 1;
export const DEFAULT_DECIMALS = 3;
